var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group color-group position-relative" },
    [
      _c("label", { staticClass: "font-size-12" }, [_vm._v(_vm._s(_vm.label))]),
      _c("div", { staticClass: "position-relative" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.iValue,
              expression: "iValue",
            },
          ],
          staticClass: "form-control",
          style: { paddingLeft: "34px" },
          attrs: { type: "text" },
          domProps: { value: _vm.iValue },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.iValue = $event.target.value
            },
          },
        }),
        _c("span", {
          staticClass: "color-preview position-absolute cursor-pointer",
          style: {
            backgroundColor: _vm.iValue,
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            boxShadow: "0px 0px 0px 1px rgba(0, 0, 0, 0.15)",
            top: "10px",
            left: "10px",
          },
          on: { click: _vm.showModal },
        }),
      ]),
      _vm.isShow
        ? _c(
            "div",
            { staticClass: "position-relative" },
            [
              _c("ColorPickerModalNew", {
                on: { closed: _vm.closedColorModal },
                model: {
                  value: _vm.iValue,
                  callback: function ($$v) {
                    _vm.iValue = $$v
                  },
                  expression: "iValue",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }